import classNames from 'classnames';
import React, { useEffect, useState, useRef } from 'react';
import validationSchema from 'utils/validationSchemas/createAccount';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from "react-hook-form";
import PhoneCountryCodePopup from 'components/modals/PhoneCountryCodePopup';
import { allCountries } from 'country-telephone-data';

import useAccount from "hooks/useAccount";
import useLogin from "hooks/useLogin";
import usePhoneVerification from 'hooks/usePhoneVerification';
import useModalDisplay from 'hooks/useDisplayModal';

import MobileVerify from 'components/modals/PhoneVerificationNew';
import ButtonWithSpinner from './buttons/ButtonSpinner';
import TCPopup from 'components/modals/T&CPopup';
import ClipLoader from "react-spinners/ClipLoader";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEyeSlash, faEye } from '@fortawesome/free-solid-svg-icons';

import { MOBILE_VERIFICATION_IMPOSE } from '../configs/constants';


const CreateAccountNew = (props) => {
    const { handlers } = props;
    const { postCreateAccountFunc } = handlers;
    // const currentStep = useRecoilValue(regStepAtom);
    const ref = useRef();
    const accountProvider = useAccount();
    const phoneVerificationProvider = usePhoneVerification(accountProvider);
    const loginProvider = useLogin();

    const { createAccount, profiles, phoneDetail, promoteChannels } = accountProvider;
    const { Name, Email } = profiles;
    const { PhoneNumber, PhoneAlpha2Code } = phoneDetail;
    const {
        PromoteWebsite, PromoteInstagram, PromoteTikTok,
        PromoteYoutube, PromoteFacebook, PromoteOnlyFans, PromoteOther,
    } = promoteChannels;

    const {open:phoneVerifyOpen, handleOpen: handleOpenPhoneVerify, handleClose:handleClosePhoneVerify} = useModalDisplay();

    const {
        handleSubmit,
        clearErrors,
        formState,
        register,
        watch,
        setValue,
        getValues,
        trigger
    } = useForm({
        mode: "onSubmit",
        defaultValues: {
            affiliateName: Name,
            email: Email,
            password: '',
            confirmPassword: '',
            phoneNumber: PhoneNumber,
            phoneCountryCode: allCountries.find(itm => itm.iso2 === (PhoneAlpha2Code ? PhoneAlpha2Code.toLowerCase() : "au")),
            website: PromoteWebsite,
            showWebsite: !!PromoteWebsite,
            instagram: PromoteInstagram,
            showInstagram: !!PromoteInstagram,
            tiktok: PromoteTikTok,
            showTiktok: !!PromoteTikTok,
            youtube: PromoteYoutube,
            showYoutube: !!PromoteYoutube,
            facebook: PromoteFacebook,
            showFacebook: !!PromoteFacebook,
            onlyfans: PromoteOnlyFans,
            showOnlyfans: !!PromoteOnlyFans,
            other: PromoteOther || "Other",
            showOther: !!PromoteOther
        },
        resolver: yupResolver(validationSchema)
    });
    const { errors, isSubmitted, isValid } = formState;

    const { affiliateName, email, password, 
        confirmPassword, phoneCountryCode, 
        phoneNumber:watchPhoneNumberVal  
    } = watch();
    

    const watchShowWebsite = watch("showWebsite", !!PromoteWebsite);
    const watchShowInstagram = watch("showInstagram", !!PromoteInstagram);
    const watchShowTiktok = watch("showTiktok", !!PromoteTikTok);
    const watchShowYoutube = watch("showYoutube", !!PromoteYoutube);
    const watchShowFacebook = watch("showFacebook", !!PromoteFacebook);
    const watchShowOnlyfans = watch("showOnlyfans", !!PromoteOnlyFans);
    const watchShowOther = watch("showOther", !PromoteOther);
   
    
    const [isPhoneNumberClicked, setIsPhoneNumberClicked] = useState(false);
    const showPhoneNumberLabel = isPhoneNumberClicked || !!watchPhoneNumberVal;
    
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [firstBtnIsClicked, setFirstBtnIsClicked] = useState(false);
   
    const [phoneVerificationResult, setPhoneVerificationResult] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const [showCreatePassword, setShowCreatePassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const [isUserDetailsFieldsValid, setIsUserDetailsFieldValid] = useState(false);
    const [countryCodeOpen, setCountryCodeOpen] = useState(false);

    const setPhoneCountryCode = (pcc) => {
        setValue("phoneCountryCode", pcc);
        setValue("phoneCountryCodeDisplay", `+${pcc.dialCode}`)
    }

    useEffect(() => {
        const iso2 = PhoneAlpha2Code ? PhoneAlpha2Code.toLowerCase() : "au";
        const pcc = allCountries.find(itm => itm.iso2 === iso2);
        setValue("phoneCountryCode", pcc);
        setValue("phoneCountryCodeDisplay", `+${pcc.dialCode}`)
    }, [setValue]) // eslint-disable-line react-hooks/exhaustive-deps

    // useEffect(()=>{
    //     if(currentStep === JOIN_STEP.VERIFY_PHONE_NUMBER) setPhoneVerifyOpen(true);
    // }, [currentStep])

    useEffect(() => setValue("affiliateName", Name), [Name, setValue]);
    useEffect(() => setValue("email", Email), [Email, setValue]);
    useEffect(() => setValue("phoneNumber", PhoneNumber), [PhoneNumber, setValue]);
    useEffect(() => setValue("phoneCountryCode", allCountries.find(itm => itm.iso2 === (PhoneAlpha2Code ? PhoneAlpha2Code.toLowerCase() : "au"))), [PhoneAlpha2Code, setValue]);
    useEffect(() => {
        setValue("website", PromoteWebsite);
        setValue("showWebsite", !!PromoteWebsite);
    }, [PromoteWebsite, setValue]);
    useEffect(() => {
        setValue("instagram", PromoteInstagram);
        setValue("showInstagram", !!PromoteInstagram);
    }, [PromoteInstagram, setValue]);
    useEffect(() => {
        setValue("tiktok", PromoteTikTok);
        setValue("showTiktok", !!PromoteTikTok);
    }, [PromoteTikTok, setValue]);
    useEffect(() => {
        setValue("youtube", PromoteYoutube);
        setValue("showYoutube", !!PromoteYoutube);
    }, [PromoteYoutube, setValue]);
    useEffect(() => {
        setValue("facebook", PromoteFacebook);
        setValue("showFacebook", !!PromoteFacebook);
    }, [PromoteFacebook, setValue]);
    useEffect(() => {
        setValue("onlyfans", PromoteOnlyFans);
        setValue("showOnlyfans", !!PromoteOnlyFans);
    }, [PromoteOnlyFans, setValue]);
    useEffect(() => {
        setValue("other", PromoteOther || "Other");
        setValue("showOther", !!PromoteOther);
    }, [PromoteOther, setValue]);

    const processCreateAccount = async (frmData, phoneDetails) => {
        if (isSubmitting) return;
        setIsSubmitting(true);

        const submittedData = {
            Name: frmData.affiliateName,
            Email: frmData.email,
            Password: frmData.password,
            phoneDetails: phoneDetails ?? {
                PhoneNumber: '',
                PhoneCountryCode: '',
                PhoneAlpha2Code: ''
            },
            PromoteChannels: {
                PromoteWebsite: frmData.showWebsite && frmData.website ? frmData.website : '',
                PromoteInstagram: frmData.showInstagram && frmData.instagram ? frmData.instagram : '',
                PromoteTikTok: frmData.showTiktok && frmData.tiktok ? frmData.tiktok : '',
                PromoteYoutube: frmData.showYoutube && frmData.youtube ? frmData.youtube : '',
                PromoteFacebook: frmData.showFacebook && frmData.facebook ? frmData.facebook : '',
                PromoteOnlyFans: frmData.showOnlyfans && frmData.onlyfans ? frmData.onlyfans : '',
                PromoteOther: frmData.showOther && frmData.other ? frmData.other : '',
            },
        };

        // isSubmitting covers both createAccount and the subsequent login step. It's left
        // true on success (rather than reset in a `finally`) so the auto-validate effect
        // below stays disabled while we navigate away instead of flipping back on and
        // re-triggering a validation flash just before the redirect.
        try {
            await createAccount.mutateAsync(submittedData);
            await loginProvider.login({ UserName: frmData.email, Password: frmData.password }, true);
            clearErrors();
            if (postCreateAccountFunc && typeof postCreateAccountFunc === "function")
                postCreateAccountFunc();
        } catch {
            // error handled by onError in useAccount / loginProvider
            setIsSubmitting(false);
        }
    };

    
    const onSubmitHandler = async (frmData, e) => {
        e.preventDefault();
        if (isSubmitting) return;

        if (!frmData.phoneNumber) {
            processCreateAccount(frmData, {
                PhoneNumber: '',
                PhoneCountryCode: '',
                PhoneAlpha2Code: ''
            });
        }
        else if(MOBILE_VERIFICATION_IMPOSE){
            if (phoneVerificationResult) {
                processCreateAccount(frmData, phoneVerificationResult);
            }
            else {
                phoneVerificationProvider.sendCode(watchPhoneNumberVal, phoneCountryCode)
                .then(()=>{handleOpenPhoneVerify();});
            }
        }
        else {
            //create account
            processCreateAccount(frmData, {
                PhoneNumber: watchPhoneNumberVal,
                PhoneCountryCode: phoneCountryCode?.dialCode ?? '',
                PhoneAlpha2Code: phoneCountryCode?.iso2 ?? ''
            });
        }
    }

    const validateUserDetails = async()=> trigger(
            [
                "affiliateName",
                "phoneCountryCode",
                "phoneNumber",
                "email",
                "password",
                "confirmPassword"
            ]
        );
    

    const handleUserDetailsValidation = async (verificationResult=null) => {
        setFirstBtnIsClicked(true);
        const isDetailValid = await validateUserDetails();
        if (isDetailValid) {
            //check user have phone or not
            if (MOBILE_VERIFICATION_IMPOSE && watchPhoneNumberVal && !verificationResult) {
                if(isLoading) return;
                setIsLoading(true);
                phoneVerificationProvider
                    .sendCode(watchPhoneNumberVal, phoneCountryCode)
                    .then(handleOpenPhoneVerify)
                    .finally(()=>{setIsLoading(false)});
                
                return;
            }
            
            setIsUserDetailsFieldValid(true);
        }
    }

    const postPhoneVerificationSuccessFunc =(result)=>{
        setPhoneVerificationResult(result);
        if(isUserDetailsFieldsValid){
            //submit the form
            if(isValid) processCreateAccount(watch(), result)
        }
        else {
            handleUserDetailsValidation(result);
        }
        handleClosePhoneVerify();
    }

    const [showTCPopup, setShowTCPopup] = useState(false);

    useEffect(() => {
        if (isSubmitting) return;
        if (affiliateName && email && password && confirmPassword) {
            validateUserDetails();
        }
    }, [affiliateName, email, password, watchPhoneNumberVal, confirmPassword, isSubmitting]);

    useEffect(() => {
        setPhoneVerificationResult(null);
    }, [watchPhoneNumberVal])

    return (
        <>
            <form className="reg-form" ref={ref} onSubmit={handleSubmit(onSubmitHandler)}>
                <div className="step one">
                    <h2>Start your application</h2>
                    <div className='fieldset-group'>
                        <div className="user-details">
                            <fieldset className="input">

                                <p className={classNames("name", "animated-label-input", { error: firstBtnIsClicked && errors?.affiliateName?.message })} >
                                    {/* {watchAffiliateNameVal && watchAffiliateNameVal.length > 0 && <label htmlFor="given-name">Affiliate name</label>} */}
                                    <label htmlFor="given-name">Affiliate name</label>
                                    <input id="given-name" type="text" placeholder=" " {...register("affiliateName")} />
                                    <span className="error-msg">{firstBtnIsClicked && errors?.affiliateName?.message}</span>
                                </p>
                            </fieldset>
                            <fieldset className="input">
                                <p className={classNames("phone", "animated-label-input", { error: firstBtnIsClicked && errors?.phoneNumber?.message })} >

                                    {/* {watchPhoneNumberVal && watchPhoneNumberVal.length > 0 && <label htmlFor="phone">Mobile number</label>} */}
                                    <label className={classNames("phone-label", { "show": showPhoneNumberLabel })} htmlFor="phone">Mobile number</label>
                                    <span className="field">
                                        <input type="hidden" id="hdnPhoneCountryCode" {...register("phoneCountryCode")} />
                                        <input className="area-code" id="area-code" type="tel" placeholder="+61" {...register("phoneCountryCodeDisplay")} onClick={() => setCountryCodeOpen(true)} readOnly />
                                        <input id="phone" className="phone" type="tel" placeholder=" "
                                            {...register("phoneNumber", {
                                                // Merge custom onBlur into React Hook Form if you want to reset click state
                                                onBlur: () => {
                                                    // Optional: removes label on blur ONLY if input is empty
                                                    if (!watchPhoneNumberVal) setIsPhoneNumberClicked(false);
                                                }
                                            })}
                                            onFocus={() => setIsPhoneNumberClicked(true)}
                                        />
                                    </span>
                                    <span className="error-msg">{firstBtnIsClicked && errors?.phoneNumber?.message}</span>
                                </p>
                            </fieldset>

                            <fieldset className="input">
                                <p className={classNames("email", "animated-label-input", { error: firstBtnIsClicked && errors?.email?.message })}>
                                    <label htmlFor="email" >Email</label>
                                    <input id="email" autoComplete="email" type="email" placeholder=" " {...register("email")} />
                                    <span className="error-msg">{firstBtnIsClicked && errors?.email?.message}</span>
                                </p>
                            </fieldset>

                            <fieldset className="input">
                                <p className={classNames("create-pass","animated-label-input", "btn-field", { error: firstBtnIsClicked && errors?.password?.message })}>
                                    <label htmlFor="create-pass" >Create your password</label>
                                    <input id="create-pass" autoComplete="new-password" type={showCreatePassword ? "text" : "password"} placeholder=" "  {...register("password")} /><span className="btn"><button className='ico-btn none-outline' onClick={(e) => { e.preventDefault(); setShowCreatePassword((prev) => !prev) }}> {showCreatePassword ? <FontAwesomeIcon className='btn-ico' icon={faEyeSlash} /> : <FontAwesomeIcon className='btn-ico' icon={faEye} />} </button></span>
                                    <span className="error-msg">{firstBtnIsClicked && errors?.password?.message}</span>
                                </p>
                                
                            </fieldset>
                            <fieldset className="input">
                                <p className={classNames("confirm-pass","animated-label-input", "btn-field", { error: firstBtnIsClicked && errors?.confirmPassword?.message })}>
                                    <label htmlFor="confirm-pass" >Confirm password</label>
                                    <input id="confirm-pass" autoComplete="new-password" type={showConfirmPassword ? "text" : "password"} placeholder=" "  {...register("confirmPassword")} /><span className="btn"><button className='ico-btn none-outline' onClick={(e) => { e.preventDefault(); setShowConfirmPassword((prev) => !prev) }}> {showConfirmPassword ? <FontAwesomeIcon className='btn-ico' icon={faEyeSlash} /> : <FontAwesomeIcon className='btn-ico' icon={faEye} />} </button></span>
                                    <span className="error-msg">{firstBtnIsClicked && errors?.confirmPassword?.message}</span>
                                </p>
                            </fieldset>
                            {
                                !isUserDetailsFieldsValid &&
                                <fieldset className="submit">
                                    <p  className={classNames("btn", "grey", "link")}>
                                        <button className={
                                            classNames("",
                                                {
                                                    'disabled':
                                                        !(
                                                            !errors.affiliateName &&
                                                            !errors.email &&
                                                            !errors.password &&
                                                            !errors.phoneNumber &&
                                                            !errors.confirmPassword
                                                        )
                                                })}

                                            type="button" onClick={(e)=>{e.preventDefault();handleUserDetailsValidation()}}><ClipLoader 
                                            color="#ffffff" loading={isLoading} 
                                            css={"display:inline-block;width:18px;height:18px;margin-right:4px;"} 
                                            size={150} /> Next</button>
                                    </p>
                                </fieldset>
                            }

                        </div>
                        {
                            isUserDetailsFieldsValid &&
                            <>
                                <fieldset className="input how-to-promote">
                                    <div className={classNames("checkbox-group", { error: (isSubmitted && !watchShowWebsite && !watchShowInstagram && !watchShowTiktok && !watchShowYoutube && !watchShowFacebook && !watchShowOnlyfans && !watchShowOther) })}>
                                        <p>Where will you promote RedHotPie?</p>

                                        <p className="website">
                                            <span className="checkbox">
                                                <input type="checkbox" id="website" name="website" {...register("showWebsite")} /><label htmlFor="website">Website</label>
                                            </span>
                                            {
                                                watchShowWebsite &&
                                                <span className={classNames("input", { error: errors?.website?.message })}>
                                                    {/* <label htmlFor="web-url">Please enter your website URL</label> */}
                                                    <input id="web-url" type="text" placeholder="Please enter your website URL" {...register("website", { required: "Please enter url", url: "Invalid url" })} />
                                                    {errors?.website?.message && <span className="error-msg">{errors?.website?.message}</span>}
                                                </span>
                                            }

                                        </p>

                                        <p className="instagram">
                                            <span className="checkbox">
                                                <input type="checkbox" id="instagram" name="instagram" {...register("showInstagram")} /><label htmlFor="instagram">Instagram</label>
                                            </span>
                                            {
                                                watchShowInstagram &&
                                                <span className={classNames("checkbox-input", { error: errors?.instagram?.message })}>
                                                    {/* <label htmlFor="instagram-url">Please enter your Instagram URL</label> */}
                                                    <input id="instagram-url" type="text" placeholder="Please enter your Instagram URL" {...register("instagram")} />
                                                    {errors?.instagram?.message && <span className="error-msg">{errors?.instagram?.message}</span>}
                                                </span>
                                            }

                                        </p>

                                        <p className="tiktok">
                                            <span className="checkbox">
                                                <input type="checkbox" id="tiktok" name="tiktok" {...register("showTiktok")} /><label htmlFor="tiktok">TikTok</label>
                                            </span>
                                            {
                                                watchShowTiktok &&
                                                <span className={classNames("input", { error: errors?.tiktok?.message })}>
                                                    {/* <label htmlFor="tiktok-url">Please enter your Tiktok channel URL</label> */}
                                                    <input id="tiktok-ur" type="text" placeholder="Please enter your Tiktok channel URL" {...register("tiktok")} />
                                                    {errors?.tiktok?.message && <span className="error-msg">{errors?.tiktok?.message}</span>}
                                                </span>
                                            }

                                        </p>

                                        <p className="youtube">
                                            <span className="checkbox">
                                                <input type="checkbox" id="youtube" name="youtube" {...register("showYoutube")} /><label htmlFor="youtube">Youtube</label>
                                            </span>
                                            {
                                                watchShowYoutube &&
                                                <span className={classNames("input", { error: errors?.youtube?.message })}>
                                                    {/* <label htmlFor="youtube-url">Please enter your Youtube channel URL</label> */}
                                                    <input id="youtube-url" type="text" placeholder="Enter your Youtube channel url" {...register("youtube")} />
                                                    {errors?.youtube?.message && <span className="error-msg">{errors?.youtube?.message}</span>}
                                                </span>
                                            }

                                        </p>

                                        <p className="facebook">
                                            <span className="checkbox">
                                                <input type="checkbox" id="facebook" name="facebook" {...register("showFacebook")} /><label htmlFor="facebook">Facebook</label>
                                            </span>
                                            {
                                                watchShowFacebook &&
                                                <span className={classNames("input", { error: errors?.facebook?.message })}>
                                                    {/* <label htmlFor="facebook-url">Please enter your Facebook URL</label> */}
                                                    <input id="facebook-url" type="text" placeholder="Please enter your Facebook URL" {...register("facebook")} />
                                                    {errors?.facebook?.message && <span className="error-msg">{errors?.facebook?.message}</span>}
                                                </span>
                                            }

                                        </p>

                                        <p className="only-fans">
                                            <span className="checkbox">
                                                <input type="checkbox" id="only-fans" name="only-fans" {...register("showOnlyfans")} /><label htmlFor="only-fans">OnlyFans</label>
                                            </span>
                                            {
                                                watchShowOnlyfans &&
                                                <span className={classNames("input", { error: errors?.onlyfans?.message })}>
                                                    {/* <label htmlFor="only-fans-url">Please enter your OnlyFans URL</label> */}
                                                    <input id="only-fans-url" type="text" placeholder="Please enter your OnlyFans URL" {...register("onlyfans")} />
                                                    {errors?.onlyfans?.message && <span className="error-msg">{errors?.onlyfans?.message}</span>}
                                                </span>
                                            }

                                        </p>

                                        <p className="other">
                                            <span className="checkbox">
                                                <input type="checkbox" id="other" name="other" {...register("showOther")} /><label htmlFor="other">Other</label>
                                            </span>
                                            {
                                                // watchShowOther &&
                                                // <span className={classNames("input", { error: errors?.other?.message })}>
                                                //     {/* <label htmlFor="other-url">Eg Email marketing, Google Adwords ...etc </label> */}
                                                //     <input id="other-url" type="text" placeholder="Eg Email marketing, Google Adwords ...etc " {...register("other")} />
                                                //     {errors?.other?.message && <span className="error-msg">{errors?.other?.message}</span>}
                                                // </span>
                                            }

                                        </p>

                                        {isSubmitted && !watchShowWebsite && !watchShowInstagram && !watchShowTiktok && !watchShowYoutube && !watchShowFacebook && !watchShowOnlyfans && !watchShowOther && errors?.promoteChannels?.message && <p className="error-msg">{errors?.promoteChannels?.message}</p>}
                                    </div>

                                    <TCPopup open={showTCPopup} close={() => setShowTCPopup(false)} />
                                </fieldset>
                                <fieldset className="submit">
                                    <p className="btn grey link">
                                        <ButtonWithSpinner className={classNames("", { "disabled": !isValid })} text={`Next`} isLoading={isSubmitting} />
                                    </p>
                                </fieldset>
                            </>
                        }

                    </div>

                </div>
                {
                    isUserDetailsFieldsValid &&
                    <p className="note">By signing up you agree to the <a href="/" onClick={e => { e.preventDefault(); setShowTCPopup(true) }} title="Click to find out more">Terms of service &amp; Privacy policy</a></p>
                }


            </form>
            {
                countryCodeOpen && <PhoneCountryCodePopup open={countryCodeOpen} close={() => setCountryCodeOpen(false)} setCountryCode={setPhoneCountryCode} defaultValue={getValues("phoneCountryCode")} />
            }
            {
                phoneVerifyOpen &&
                <MobileVerify 
                    provider={phoneVerificationProvider}
                    phoneNumber={watchPhoneNumberVal}
                    countryCode={phoneCountryCode} 
                    open={phoneVerifyOpen} 
                    close={handleClosePhoneVerify}
                    postProcessFunc={postPhoneVerificationSuccessFunc}
                />
            }

        </>
    );

}

export default CreateAccountNew;